/**
 * Catálogo de peleadores reutilizable. La pelea guarda un snapshot; esto es el maestro.
 */
import { z } from 'zod';

export const FighterSchema = z.object({
  id: z.string().length(26),
  orgId: z.string().min(1),
  name: z.string().min(1).max(80),
  crew: z.string().max(80).nullable(),
  recordWins: z.number().int().nonnegative(),
  recordLosses: z.number().int().nonnegative(),
  recordDraws: z.number().int().nonnegative(),
  photoUrl: z.string().url().nullable(),
  active: z.boolean(),
  createdAt: z.string().datetime({ offset: true }),
});
export type Fighter = z.infer<typeof FighterSchema>;
